import React, { useState } from 'react';
import PropTypes from 'prop-types';

import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import sleep from 'shared-utils/src/sleep';

import PencilIcon from 'shared-vectors/icons/Pencil';
import { Icon } from 'shared-vectors';

import InputContainer from '../../../../InputContainer';

const Title = ({
  searchTitle,
  setSearchTitle,
  sectionTitleCls,
}) => {
  const [trackStartEditing, setTrackStartEditing] = useState(true);

  const onStartEditing = () => {
    if (trackStartEditing) {
      sleep(300).then(() => trackGTMEvents({
        category: 'FavouriteAndAlert',
        action: 'StartEditingAlertParameter',
        label: 'Name',
      }, {}, true));
      setTrackStartEditing(false);
    }
  };

  return (
    <>
      <p className={sectionTitleCls}>
        NOME DELLA RICERCA (opzionale)
      </p>
      <InputContainer
        type="text"
        value={searchTitle}
        placeholder="Dai un titolo alla tua ricerca"
        onChange={setSearchTitle}
        onFocus={onStartEditing}
        iconClose
        iconAfter={(
          <Icon
            name={PencilIcon}
            color="f3"
            heigth="10px"
            width="20px"
          />
        )}
      /> 
    </> 
  );
};

export default Title;

Title.propTypes = {
  searchTitle: PropTypes.string,
  setSearchTitle: PropTypes.func,
  sectionTitleCls: PropTypes.string,
};
Title.defaultProps = {
  searchTitle: '',
  setSearchTitle: () => {},
  sectionTitleCls: '',
};